
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.563 3.497A1.08 1.08 0 0120.97 5.13l-7.156 7.157 7.156 7.156a1.08 1.08 0 01-1.406 1.632l-.121-.105-7.156-7.156-7.157 7.156-.12.105a1.08 1.08 0 01-1.407-1.632l7.157-7.156-7.157-7.157a1.08 1.08 0 011.406-1.632l.121.105 7.157 7.157 7.156-7.157z","fill":"#363636","fill-rule":"nonzero"}})])
          )
        }
      }
    